export const LayoutEnum = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const
export type LayoutEnumType = keyof typeof LayoutEnum // 'HORIZONTAL' | 'VERTICAL'

const yearFormat = 'YYYY'
const monthFormat = 'YYYY-MM'
const weekFormat = 'MM-DD'
const dateFormat = 'YYYY-MM-DD'
export const FormatMap = {
  year: yearFormat,
  month: monthFormat,
  week: weekFormat,
  date: dateFormat,
}
